import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import type { ShiftsRowsDispatch } from './reducers/shiftsRows'
import shiftRowsReducer, { ShiftsRowState, initialShiftsRowState } from './reducers/shiftsRows'

type Context = [ShiftsRowState, ShiftsRowsDispatch]

const { context: ShiftsRowsContext, hook: useShiftsRows } = createContext<Context>()

const ShiftsRowsProvider = ({ children }: React.PropsWithChildren) => {
  const memoizedReducer = useCallback(shiftRowsReducer, [])
  const [state, dispatch] = React.useReducer(memoizedReducer, initialShiftsRowState())

  return (
    <ShiftsRowsContext.Provider value={[state, dispatch]}>{children}</ShiftsRowsContext.Provider>
  )
}

export { ShiftsRowsProvider, useShiftsRows }
